import React, { useState, useEffect } from 'react'
import './ContactoPage.scss'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import axios from 'axios'
import { DobleGuion } from '../components/DobleGuion'
import { GoLocation, GoMail } from 'react-icons/go'
import { FiPhone } from 'react-icons/fi'
import { PrintIcon } from '../utils/icons'
import { scrollBodyTop } from '../hooks/scrollPosition'
import { showPopup } from '../actions'
import { comprobarDatos } from '../hooks/validateForm'
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { API, BRANDCHOSEN } from '../hooks/config'

const ContactoPage = (props) => {
    const { zones } = props
    const [acceptPrivacy, setAcceptPrivacy] = useState(false)
    const contactoInfoInit = {
        location: {
            name: 'Fabricación Alfarera Navarrete, S.A.U.',
            direccionL1: 'Carretera Entrena 38 26370',
            direccionL2: 'Navarrete La Rioja. España',
            telefono: '+34 941 44 00 00',
            fax: '+34 941 44 06 45',
            email: 'info@fansa.es'
        },
        timePhone: {
            title: 'Horario de Atención Telefónica',
            data1: 'Lunes a Viernes',
            data2: '8:00 - 16:00'
        },
        timeStore: {
            title: 'Horario de Almacén',
            data1: 'Lunes a Viernes',
            data2: '9:00 - 13:00 / 14:30 - 18:00'
        },
        map: {
            title: 'Nos encuentras en:',
            img: '/static/img/map.png'
        }
    }

    const reglas = {
        name: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
        },
        email: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
            email: { message: 'con un formato invalido' },
        },
        phoneNumber: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
            format: { pattern: '[0-9]+', message: 'solo puede contener digitos del 0 al 9' },
        },
        zone: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
        },
        comments: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
        },
    };

    const [userContact, setUserContact] = useState({
        company: '',
        name: '',
        email: '',
        phoneNumber: '',
        zone: 'zona',
        comments: ''
    })

    useEffect(() => {
        scrollBodyTop()
    }, [])

    const handleClick = () => {
        const alias = {
            name: 'nombre',
            phoneNumber: 'teléfono',
            comments: 'Observaciones',
        }
        comprobarDatos(userContact, reglas, alias).then(res => {
            const headers = {
                headers: {
                    'Content-Type': 'application/json',
                }
            };
            axios.post(`${API}/contact`, {
                company: userContact.company,
                name: userContact.name,
                phoneNumber: userContact.phoneNumber,
                email: userContact.email,
                zone: userContact.zone,
                comments: userContact.comments,
            }, headers).then(res => {
                props.showPopup({ active: true, message: 'Observaciones enviadas', type: 'success' })
            }).catch(err => {
                props.showPopup({ active: true, message: 'Error al enviar', type: 'error' })
            });
        }).catch(err => {
            props.showPopup({ active: true, message: err, type: 'error' })
        })
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        setUserContact(() => ({
            ...userContact,
            [name]: value
        }))
    }

    return (
        <div className='contacto-page-container'>
            <div className="header">
                <img className="movil" src="/static/img/header-contacto-m.jpg" alt="" />
                <img className="tablet" src="/static/img/header-contacto-t.jpg" alt="" />
                <img className="escritorio" src="/static/img/header-contacto.jpg" alt="" />
            </div>
            <div className="form-info">
                <div className="form">
                    <div className="title">
                        <p> La forma más sencilla de ponerte en contacto con nosotros es utilizando este formulario</p>
                    </div>
                    <div className="input-block name">
                        <label htmlFor="name">Nombre y apellidos *</label>
                        <div className="input">
                            <input type="text" name="name" onChange={handleChange} value={userContact.name} />
                        </div>
                    </div>
                    <div className="input-block email">
                        <label htmlFor="email">Email *</label>
                        <div className="input">
                            <input type="text" name="email" onChange={handleChange} value={userContact.email} />
                        </div>
                    </div>
                    <div className="input-block company">
                        <label htmlFor="company">Empresa</label>
                        <div className="input">
                            <input type="text" name="company" onChange={handleChange} value={userContact.company} />
                        </div>
                    </div>
                    <div className="input-block phoneNumber">
                        <label htmlFor="phoneNumber">Teléfono *</label>
                        <div className="input">
                            <input type="text" name="phoneNumber" onChange={handleChange} value={userContact.phoneNumber} />
                        </div>
                    </div>
                    <div className="input-block select">
                        <label htmlFor="zone">Zona *</label>
                        <Select
                            MenuProps={{
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left"
                                },
                                transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                getContentAnchorEl: null
                            }}
                            name="zone"
                            IconComponent={ArrowForwardIosIcon}
                            value={userContact.zone}
                            id="select"
                            onChange={handleChange}>
                            <MenuItem value="">Elija una opción</MenuItem>
                            {zones.region.map((zone, index) => {
                                return (
                                    <MenuItem className={zones.region.length - 1 === index ? "regions-end" : ""} value={zone.Name} key={index}>{zone.Name}</MenuItem>
                                )
                            })}
                            {zones.country.map((zone, index) => {
                                return (
                                    <MenuItem value={zone.Name} key={index}>{zone.Name}</MenuItem>
                                )
                            })}
                        </Select>
                    </div>
                    <div className="input-block textarea">
                        <label htmlFor="comments">Mensaje *</label>
                        <div className="input">
                            <textarea id="comment" cols="30" rows="5" name="comments" value={userContact.comments} onChange={handleChange} placeholder="Cuéntanos algún detalle que debamos saber"></textarea>
                        </div>
                    </div>
                    <div className="privacy-policies">
                        <input className="oculto accept" id="accept" type="checkbox" name="accept" onChange={() => setAcceptPrivacy(!acceptPrivacy)} value={acceptPrivacy} />
                        <label className="check-automatico" htmlFor="accept">
                            <p></p>
                        </label>
                        <label className="check-data" htmlFor="checkbox">Acepto la <Link to="/politica-de-privacidad">política de privacidad</Link> y confirmo que mi información personal se puede utilizar de acuerdo con la ley. *</label>
                    </div>
                    <div className="required">
                        <p>*Campos obligatorios</p>
                    </div>
                    <div className="buttons">
                        {
                            acceptPrivacy ?
                                <button className="btn" onClick={handleClick}>Enviar</button>
                                :
                                <button className="btn btn-light no-pointer">Enviar</button>
                        }
                    </div>
                </div>
                <div className="info-location">
                    <div className="location">
                        <div className="title">
                            <p>{contactoInfoInit.location.name} </p>
                            <DobleGuion />
                        </div>
                        <div className="data direction">
                            <div className="icon"><GoLocation size={20} /></div>
                            <div className="text">
                                <p>{contactoInfoInit.location.direccionL1}</p>
                                <p>{contactoInfoInit.location.direccionL2}</p>
                            </div>
                        </div>
                        <div className="data phone">
                            <div className="icon"><FiPhone size={20} /></div>
                            <div className="text">
                                <p>{contactoInfoInit.location.telefono}</p>
                            </div>
                        </div>
                        <div className="data">
                            <div className={`icon icon-color-${BRANDCHOSEN}`}>
                              <PrintIcon size={20} />
                            </div>
                            <div className="text">
                                <p>{contactoInfoInit.location.fax}</p>
                            </div>
                        </div>
                        <div className="data">
                            <div className="icon"><GoMail size={20} /></div>
                            <div className="text">
                                <p>{contactoInfoInit.location.email}</p>
                            </div>
                        </div>
                    </div>
                    <div className="time-phone">
                        <div className="title">
                            <p>{contactoInfoInit.timePhone.title} </p>
                            <DobleGuion />
                        </div>
                        <div className="data">
                            <p><strong>{contactoInfoInit.timePhone.data1}</strong>{contactoInfoInit.timePhone.data2}</p>
                        </div>
                    </div>
                    <div className="time-phone">
                        <div className="title">
                            <p>{contactoInfoInit.timeStore.title} </p>
                            <DobleGuion />
                        </div>
                        <div className="data">
                            <p><strong>{contactoInfoInit.timeStore.data1}</strong>{contactoInfoInit.timeStore.data2}</p>
                        </div>
                    </div>
                    <div className="map">
                        <div className="title">
                            <p>{contactoInfoInit.map.title}</p>
                            <DobleGuion />
                        </div>
                        <a href="https://goo.gl/maps/D4R1WK7hY7LqmwBX7" target="_blank"><img src={contactoInfoInit.map.img} alt="" /></a>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapDispatchToProps = {
    showPopup
}

const mapStateToProps = state => state

export default connect(mapStateToProps, mapDispatchToProps)(ContactoPage)